export default "__VITE_ASSET__DdX0P4xc__"